<div class="docs-achat">
  <h4 class="docs-achat-title">
    {{ 'documentsAchat.title' | translate }}
    <app-help-tip textKey="documentsAchat.subtitle" />
  </h4>

  @if (loading) {
    <p class="logements-status">{{ 'common.loading' | translate }}</p>
  }
  @if (loadError) {
    <p class="logements-status logements-status--error">
      {{ 'documentsAchat.loadError' | translate }}
    </p>
  }
  @if (listReloadError) {
    <p class="logements-status logements-status--error">
      {{ 'documentsAchat.reloadError' | translate }}
    </p>
  }

  @if (!loading) {
    <ul class="logements-list">
      @for (ligne of lignes; track ligne.type) {
        <li class="logements-row">
          <div class="logements-row-main">
            <h4 class="logements-row-title">
              <span>
                {{ 'documentsAchat.types.' + ligne.type | translate }}
              </span>
              <span
                class="docs-status"
                [class.docs-status--ok]="ligneOk(ligne)"
                [class.docs-status--ko]="!ligneOk(ligne)"
                [title]="
                  (ligneOk(ligne)
                    ? 'documentsAchat.ligneOk'
                    : 'documentsAchat.ligneKo'
                  ) | translate
                "
                [attr.aria-label]="
                  (ligneOk(ligne)
                    ? 'documentsAchat.ligneOk'
                    : 'documentsAchat.ligneKo'
                  ) | translate
                "
              >
                <fa-icon [icon]="ligneOk(ligne) ? 'check' : 'xmark'"></fa-icon>
              </span>
            </h4>
            <p>
              {{
                (ligne.document
                  ? 'documentsAchat.statut.present'
                  : 'documentsAchat.statut.manquant'
                ) | translate
              }}
              @if (fileLabel(ligne)) {
                <span> · {{ fileLabel(ligne) }}</span>
              }
            </p>
            @if (dateDocumentLabel(ligne)) {
              <p class="docs-meta">
                {{ 'documentsAchat.dateDocument' | translate }}
                :
                {{ dateDocumentLabel(ligne) }}
              </p>
            }
          </div>
          <div class="logements-row-actions">
            @if (ligne.document) {
              <button
                type="button"
                class="logements-row-action"
                [title]="'documentsAchat.view' | translate"
                [attr.aria-label]="'documentsAchat.view' | translate"
                [disabled]="isBusy"
                (click)="openViewer(ligne)"
              >
                <fa-icon icon="eye"></fa-icon>
              </button>
            }
            <button
              type="button"
              class="logements-row-action"
              [title]="
                (ligne.document
                  ? 'documentsAchat.replace'
                  : 'documentsAchat.upload'
                ) | translate
              "
              [attr.aria-label]="
                (ligne.document
                  ? 'documentsAchat.replace'
                  : 'documentsAchat.upload'
                ) | translate
              "
              [disabled]="isBusy"
              (click)="openUpload(ligne)"
            >
              <fa-icon
                [icon]="ligne.document ? 'arrows-rotate' : 'upload'"
              ></fa-icon>
            </button>
            @if (ligne.document) {
              <button
                type="button"
                class="logements-row-action logements-row-action--danger"
                [title]="'common.delete' | translate"
                [attr.aria-label]="'common.delete' | translate"
                [disabled]="isBusy"
                (click)="askDelete(ligne)"
              >
                <fa-icon [icon]="['far', 'trash-can']"></fa-icon>
              </button>
            }
          </div>
        </li>
      }
    </ul>
  }
</div>

<dialog
  #uploadDialog
  class="logements-dialog"
  aria-labelledby="upload-document-achat-title"
  (cancel)="onUploadDialogCancel($event)"
>
  @if (uploadType) {
    <h3 id="upload-document-achat-title">
      {{
        (uploadIsReplace
          ? 'documentsAchat.replaceTitle'
          : 'documentsAchat.uploadTitle'
        ) | translate
      }}
    </h3>
    <p>{{ 'documentsAchat.types.' + uploadType | translate }}</p>

    <form
      class="logements-form"
      [formGroup]="uploadForm"
      (ngSubmit)="submitUpload()"
    >
      <label [class.is-invalid]="uploadFileError">
        {{ 'documentsAchat.file' | translate }}
        <input
          type="file"
          accept=".pdf,application/pdf,image/*"
          (change)="onFileSelected($event)"
        />
        <span class="docs-file-hint">
          {{ 'documentsAchat.fileHint' | translate }}
        </span>
        @if (uploadFile) {
          <span class="docs-file-name">{{ uploadFile.name }}</span>
        }
        @if (uploadFileError) {
          <span class="logements-field-error">
            {{ 'documentsAchat.fileRequired' | translate }}
          </span>
        }
      </label>

      <label>
        {{ 'documentsAchat.dateDocument' | translate }}
        <span class="docs-optional">{{ 'common.optional' | translate }}</span>
        <input type="date" formControlName="dateDocument" />
      </label>

      @if (uploadErrorMessage) {
        <p class="logements-status logements-status--error">
          {{ uploadErrorMessage }}
        </p>
      }

      <div class="logements-dialog-actions">
        <button
          type="button"
          class="logements-cancel"
          [disabled]="uploading"
          (click)="cancelUpload()"
        >
          {{ 'common.cancel' | translate }}
        </button>
        <button
          type="submit"
          class="logements-action-btn"
          [disabled]="uploading"
        >
          {{
            uploading
              ? ('documentsAchat.uploading' | translate)
              : uploadIsReplace
                ? ('documentsAchat.replace' | translate)
                : ('documentsAchat.upload' | translate)
          }}
        </button>
      </div>
    </form>
  }
</dialog>

<app-document-delete-dialog
  i18nPrefix="documentsAchat"
  [active]="deleteSession.active"
  [typeLabel]="deleteTypeLabel"
  [fileName]="deleteFileName"
  [deleting]="deleteSession.deleting"
  [errorMessage]="deleteSession.errorMessage"
  (cancelRequest)="cancelDelete()"
  (confirmRequest)="confirmDelete()"
  (dialogCancel)="onDeleteDialogCancel($event)"
/>

<app-document-viewer-dialog
  i18nPrefix="documentsAchat"
  [session]="viewer"
  (download)="downloadViewerFile()"
  (closeRequest)="closeViewer()"
  (openExternally)="openViewerExternally()"
  (dialogCancel)="onViewerDialogCancel($event)"
/>
